import React from 'react';
import type { ExtrasDue } from '../../../../api/stays-alerts-client';

/**
 * EXTRAS DUE (plan S8, SC-2; K-59). A reserved slot: it renders NOTHING while
 * the server says `available: false` — Lobbero does not track guest payments
 * until plan S10, which registers the provider and fills this component.
 */
export const ExtrasDueSlot: React.FC<{ extras: ExtrasDue | null | undefined }> = ({ extras }) => {
  if (!extras || !extras.available) return null;

  return null;
};
